// eslint-disable-next-line import/prefer-default-export
export const BREAKPOINTS = {
  TABLET: 768,
  TABLET_LANDSCAPE: 1024,
  DESKTOP_MAP: 992,
  DESKTOP: 1280,
  WIDE: 1600
};
